import { useContext } from 'react';
import { MultistepApiContext } from '../Context.js';

function useMultistepApi() {
  return useContext(MultistepApiContext);
}

export { useMultistepApi };
